<div class="captura-biometrica">
    <fortface-sdk  #forfacesdk></fortface-sdk>
</div>
